import React from 'react';
import { Main } from './styled';
import * as assets from '@assets';
import { CustomizedButton } from '@components/Customized';
import { useHistory } from 'react-router-dom';

const NotFoundPresenter: React.FC = () => {
  const history = useHistory();

  return (
    <React.Fragment>
      <Main>
        <p className="title">Ooops!</p>
        <p className="description">요청하신 페이지가 존재하지 않습니다.</p>
        <img src={assets.SadMans4} alt="error" />
        <CustomizedButton
          color="primary"
          variant="contained"
          size="large"
          disableElevation
          onClick={() => {
            history.replace('/');
          }}
        >
          비교견적 메인으로 돌아가기
        </CustomizedButton>
      </Main>
    </React.Fragment>
  );
};

export default NotFoundPresenter;
